import { arrayOf, number } from 'prop-types'
import React from 'react'
import StatsItem from './StatsItem'

const YearBuiltOrRenovated = (props) => {
  if (props.yearRenovated.length === 0) {
    return (
      <StatsItem
        heading="Year built"
        slug="year-built"
        value={props.yearBuilt}
      />
    )
  }
  return (
    <StatsItem
      heading="Year renovated"
      slug="year-renovated"
      value={props.yearRenovated.join(', ')}
    />
  )
}
YearBuiltOrRenovated.defaultProps = {
  yearBuilt: null,
  yearRenovated: [],
}
YearBuiltOrRenovated.propTypes = {
  yearBuilt: number,
  yearRenovated: arrayOf(number),
}

export default YearBuiltOrRenovated
